enum DataProvider {
	BOOKING = 'BOOKING',
	HOTELS_COM = 'HOTELS_COM',
	AGODA = 'AGODA',
	EXPEDIA = 'EXPEDIA',
	GOOGLE = 'GOOGLE',
	TRIP_ADVISOR = 'TRIP_ADVISOR',
	TRIP_COM = 'TRIP_COM',
	PRICELINE = 'PRICELINE',
	WEBHOTELIER = 'WEBHOTELIER',
	HILTON = 'HILTON',
	BRAND_COM = 'BRAND_COM',
	HOLIDAYCHECK = 'HOLIDAYCHECK',
	TRAVELSUPERMARKET = 'TRAVELSUPERMARKET',
	TUIUK = 'TUIUK',
	TUIDE = 'TUIDE',
	JET2 = 'JET2',
	AIRBNB = 'AIRBNB',
}

export const providersWithNoFlightSupport: Set<DataProvider> = new Set([
	DataProvider.BOOKING,
	DataProvider.HOTELS_COM,
	DataProvider.AGODA,
	DataProvider.EXPEDIA,
	DataProvider.GOOGLE,
	DataProvider.TRIP_ADVISOR,
	DataProvider.TRIP_COM,
	DataProvider.PRICELINE,
	DataProvider.WEBHOTELIER,
	DataProvider.HILTON
]);

export const providersWithFlightSupport: Set<DataProvider> = new Set([
	DataProvider.HOLIDAYCHECK,
	DataProvider.TRAVELSUPERMARKET,
	DataProvider.TUIUK,
	DataProvider.TUIDE,
	DataProvider.JET2,
]);

export default DataProvider;
